module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8617/img/iphone-frame.png"